function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.748 6.405V8.41c-.033.418.058.853.273 1.174.372.555.976.555 1.349 0l3.139-3.346c.062-.052.121-.115.176-.189l.035-.037c.188-.28.281-.646.28-1.012 0-.159-.017-.318-.052-.47-.084-.372-.268-.675-.506-.838L17.37.417c-.373-.556-.977-.556-1.35 0-.214.32-.305.755-.272 1.173v1.972H.954C.427 3.562 0 4.198 0 4.983s.427 1.422.954 1.422h14.794z",
  fill: "currentColor"
});

var SvgArrowRightBig = function SvgArrowRightBig(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='21' height='10' viewBox='0 0 21 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.7481 6.40467V8.41037C15.7149 8.82809 15.8057 9.26347 16.0206 9.58384C16.3931 10.139 16.9971 10.1387 17.3699 9.58318L20.5087 6.23751C20.571 6.18601 20.6303 6.12332 20.6852 6.04942L20.7203 6.01198C20.9078 5.73261 21.001 5.366 21 4.99996C21.0004 4.84109 20.9831 4.68211 20.948 4.53021C20.8641 4.15797 20.6795 3.85458 20.4424 3.69172L17.3699 0.416881C16.9971 -0.138677 16.3931 -0.138975 16.0206 0.416075C15.8057 0.736567 15.7149 1.17196 15.7481 1.58966V3.56173H0.95439C0.427256 3.56173 0 4.19815 0 4.98329C0 5.76833 0.427256 6.40467 0.95439 6.40467H15.7481Z' fill='currentColor'/%3E %3C/svg%3E";
export { SvgArrowRightBig as ReactComponent };